export default __webpack_public_path__ + "static/media/inspirationon.e776c962.svg";